import React from "react";

/**
 * Reusable Auto Scroll Banner
 * @param {Array} items - Array of objects with { image, text }
 * @param {string} bgColor - Tailwind background color
 * @param {string} textColor - Tailwind text color
 * @param {number} speed - Animation speed (seconds)
 */
export default function AutoScrollBanner({
  items = [],
  bgColor = "bg-gray-50",
  textColor = "text-gray-700",
  speed = 25,
}) {
  if (!items.length) return null;

  return (
    <div className={`relative overflow-hidden border-t border-b border-gray-200 ${bgColor}`}>
  <div
    className="flex whitespace-nowrap animate-scroll will-change-transform"
    style={{
      animationDuration: `${speed}s`,
      width: "max-content",
    }}
  >
    {/* Duplicate content for seamless loop */}
    {Array(2)
      .fill([...items])
      .flat()
      .map((item, idx) => (
        <div
          key={idx}
          className={`flex items-center gap-3 px-8 py-4 font-medium shrink-0 ${textColor}`}
        >
          {item.image && (
            <img
              src={item.image}
              alt={item.text}
              width={24}
              height={24}
              decoding="async"
              className="w-6 h-6 object-contain"
            />
          )}
          <span className="whitespace-nowrap">{item.text}</span>
        </div>
      ))}
  </div>
</div>

  );
}
